module.exports = __webpack_public_path__ + "img/anvil_splash3.3660d5f0.png";